import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
import * as React from "react";
import { useTranslation } from "hhn-commons";

interface InputDeviceIdProps {
  value: string;
  onChangeValue: (value: string) => void;
  onIconClick: () => void;
}

const InputDeviceId = ({
  value,
  onChangeValue,
  onIconClick,
}: InputDeviceIdProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });

  return (
    <FormControl variant="outlined" sx={{ width: "100%" }}>
      <OutlinedInput
        id="outlined-adornment-weight"
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={onIconClick}>
              <CheckIcon />
            </IconButton>
          </InputAdornment>
        }
        value={value}
        onChange={e => onChangeValue(e.target.value)}
        aria-describedby="outlined-weight-helper-text"
        size="small"
        placeholder={tNs("enterDeviceId")}
        data-testid="add-device-input-box"
      />
    </FormControl>
  );
};

export default InputDeviceId;
